import { render, staticRenderFns } from "./CheckOrder.vue?vue&type=template&id=5ff50ab5&scoped=true"
import script from "./CheckOrder.vue?vue&type=script&lang=js"
export * from "./CheckOrder.vue?vue&type=script&lang=js"
import style0 from "./CheckOrder.vue?vue&type=style&index=0&id=5ff50ab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff50ab5",
  null
  
)

export default component.exports